'use client';

import { faShare, faTimes } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@pickleballinc/ui/components/ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@pickleballinc/ui/components/ui/dialog';
import { toast } from 'react-toastify';

import { useOrganizationStore } from '@/store/organization-store';
import { generateInvitationMessage } from '@/utils/helpers';

interface InviteCodeModalProps {
	open: boolean;
	onClose: () => void;
	invitationCode: string;
	leagueTitle: string;
	seasonUuid: string;
}

export const InviteCodeModal = ({ open, onClose, invitationCode, leagueTitle, seasonUuid }: InviteCodeModalProps) => {
	const { teamLeagueUuid, organizationUuid } = useOrganizationStore();

	return (
		<Dialog
			open={open}
			onOpenChange={(o) => {
				if (!o) onClose();
			}}
		>
			<DialogContent className="max-w-[340px] rounded-lg sm:max-w-[524px] gap-0 p-6" hideClose>
				<DialogHeader className="flex w-full items-end justify-between flex-row">
					<DialogTitle>Invite with code</DialogTitle>
					<FontAwesomeIcon icon={faTimes} size="xl" className="text-gray-500 cursor-pointer" onClick={onClose} />
				</DialogHeader>
				<div>
					<div className="my-[18px] flex items-center text-base font-bold leading-6 text-gray-800">
						<span>Current code:</span>
						<span className="ml-1 text-base font-bold leading-6 text-[#36F]">{invitationCode}</span>
					</div>

					<hr className="mb-6 h-px rounded-md bg-brand-300" />

					<span className="text-base font-medium leading-6 text-gray-900">
						Click Share the code to copy to clipboard and paste to share.
					</span>

					<Button
						onClick={() => {
							const clipboardText = generateInvitationMessage(
								leagueTitle,
								invitationCode,
								organizationUuid,
								teamLeagueUuid,
								seasonUuid
							);
							navigator.clipboard.writeText(clipboardText);
							toast.success('Code copied to clipboard.');
							onClose();
						}}
						type="button"
						className="mt-[50px] h-12 w-full text-base font-semibold leading-7"
					>
						<FontAwesomeIcon icon={faShare} />
						<span className="ml-2">Share the code</span>
					</Button>
				</div>
			</DialogContent>
		</Dialog>
	);
};
